const dummyProps = {
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit'
}

export const typographyElementsMap = {
  h1: {
    breakpoints: {
      640: { fontSize: 40, fontWeight: 500, lineHeight: '120%' },
      992: { fontSize: 48, fontWeight: 500, lineHeight: '120%' },
      1200: { fontSize: 60, fontWeight: 500, lineHeight: '120%' }
    }
  },
  h2: {
    breakpoints: {
      640: { fontSize: 32, fontWeight: 500, lineHeight: '120%' },
      992: { fontSize: 40, fontWeight: 500, lineHeight: '120%' },
      1200: { fontSize: 48, fontWeight: 500, lineHeight: '120%' }
    }
  },
  h3: {
    breakpoints: {
      640: { fontSize: 28, fontWeight: 500, lineHeight: '120%' },
      992: { fontSize: 28, fontWeight: 500, lineHeight: '120%' },
      1200: { fontSize: 32, fontWeight: 500, lineHeight: '120%' }
    }
  },
  h4: {
    breakpoints: {
      640: { fontSize: 24, fontWeight: 500, lineHeight: '120%' },
      992: { fontSize: 24, fontWeight: 500, lineHeight: '120%' },
      1200: { fontSize: 24, fontWeight: 500, lineHeight: '120%' }
    }
  },
  h5: {
    breakpoints: {
      640: { fontSize: 21, fontWeight: 700, lineHeight: '120%' },
      992: { fontSize: 21, fontWeight: 700, lineHeight: '120%' },
      1200: { fontSize: 21, fontWeight: 700, lineHeight: '120%' }
    }
  },
  h6: {
    breakpoints: {
      640: { fontSize: 18, fontWeight: 700, lineHeight: '120%' },
      992: { fontSize: 18, fontWeight: 700, lineHeight: '120%' },
      1200: { fontSize: 18, fontWeight: 700, lineHeight: '120%' }
    }
  },
  p: {
    breakpoints: {
      640: { fontSize: 16, fontWeight: 400, lineHeight: '140%' },
      992: { fontSize: 16, fontWeight: 400, lineHeight: '140%' },
      1200: { fontSize: 18, fontWeight: 400, lineHeight: '140%' }
    }
  },
  small: {
    breakpoints: {
      640: { fontSize: 14, fontWeight: 400, lineHeight: '140%' },
      992: { fontSize: 14, fontWeight: 400, lineHeight: '140%' },
      1200: { fontSize: 16, fontWeight: 400, lineHeight: '140%' }
    }
  },
  span: {
    breakpoints: {
      640: dummyProps,
      992: dummyProps,
      1200: dummyProps
    }
  },
  label: {
    breakpoints: {
      640: dummyProps,
      992: dummyProps,
      1200: dummyProps
    }
  }
}
